import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Card, Accordion, Button } from "react-bootstrap";
import { FaGlobeAmericas, FaRegGem, FaBullseye } from "react-icons/fa";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./WhyChooseUs.css";

const valuesData = [
  {
    title: "The Divine Legacy of Barsana",
    content:
      "A Land Steeped in Spirituality Welcome to Barsana: The Sacred Abode of Radha Rani Nestled in the heart of Uttar Pradesh's Braj region, Barsana is a town that resonates with divine love and timeless spirituality. Revered as the birthplace of Goddess Radha, the eternal consort of Lord Krishna, Barsana is a jewel of Hindu pilgrimage and cultural heritage. This historic town, located just 46 km from Mathura, is surrounded by four sacred hills symbolizing the four heads of Lord Brahma, earning it the ancient name Brahmasarin. For over 5,000 years, Barsana has captivated the hearts of devotees and travelers with its mystical charm and serene landscapes.A Tapestry of Myth and History Barsana's history is woven with legends of divine love. According to mythology, King Vrishabhanu, Radha's father, made Bhanugarh Hill his home, where the iconic Radha Rani Temple now stands. Established by King Vajranabh, Krishna's great-grandson, around 5,000 years ago, the temple was later rediscovered and rebuilt in 1675 AD by Raja Bir Singh Deo in majestic Rajput style. The town's winding lanes echo tales of Radha and Krishna's playful childhood, their divine Raas Leela, and their eternal bond, making Barsana a living testament to their love. Cultural Vibrance and Festive Splendor Barsana is synonymous with its vibrant festivals, particularly Lathmar Holi and Laddu Holi, which draw global attention. During Lathmar Holi, women playfully chase men with sticks, reenacting Krishna's teasing of Radha, while Laddu Holi sees sacred sweets thrown from the Radha Rani Temple as prasad. Celebrated with unmatched fervor, these festivals, along with Radhashtami and Krishna Janmashtami, transform Barsana into a kaleidoscope of colors and devotion, offering residents a front-row seat to India's richest cultural traditions. Why Barsana for Your Dream Home? Choosing Barsana for your residence is an invitation to live amidst divine serenity and cultural richness. Our 32-acre premium township, adorned with exquisite landscaping by one of India's most celebrated artists, blends modern luxury with Barsana's spiritual essence. Here, every sunrise over the sacred hills promises peace, and every festival fills your home with joy. Welcome to a lifestyle where divinity meets elegance.",
  },
  {
    title: " Unique Features of Barsana ",
    content:
      "A Blend of Nature and DivinitySacred Landmarks and Spiritual Sanctuaries Barsana is a treasure trove of sacred sites that inspire awe and devotion. The Radha Rani Temple, perched atop Bhanugarh Hill, is the town's crown jewel. Built with red sandstone in Rajput architectural style, it features intricate carvings, vibrant murals of Radha-Krishna's love story, and a gilded statue of Radha alongside Krishna. Nearby, the Ladliji Temple (built in 1675) and Kirti Temple, dedicated to Radha's mother, offer serene spaces for worship. The Prem Sarovar, a sacred lake believed to be the meeting place of Radha and Krishna, and Pila Pokhar, a reservoir tied to their childhood, add to the town's mystical allure. Natural Beauty and Scenic Hills Surrounded by Brahma, Vishnu, Shiva, and Shesha Hills, Barsana is a haven of natural beauty. These four peaks, each crowned with a temple, create a picturesque backdrop that soothes the soul. The lush greenery, rolling landscapes, and tranquil ponds make Barsana ideal for those seeking a peaceful retreat from urban chaos. The town's location along the Agra-Delhi National Highway (NH-44) and proximity to the Yamuna Expressway ensures seamless connectivity to Delhi (124 km) and Agra (102 km), blending rural charm with urban accessibility. A Community Rooted in Tradition Barsana's close-knit community, with a population of approximately 11,184 (2011 Census), thrives on its spiritual and cultural heritage. The Yadav community, historically tied to cowherding, infuses the town with warmth and tradition. With a literacy rate of 69.88%, higher than the state average, Barsana balances its ancient roots with modern aspirations, making it an ideal setting for families seeking a harmonious lifestyle. Your Premium Oasis in Barsana ur township redefines luxury living in this sacred land. Spanning 32 acres, it features top-tier landscaping crafted by a renowned Indian artist, transforming your home into a masterpiece of design and nature. With gated security, 24/7 utilities, lush parks, and a dedicated temple within the township, your residence in Barsana offers unmatched tranquility and sophistication, perfectly complementing the town's divine ambiance.",
  },
  {
    title: "Future Growth of Barsana",
    content:
      "A Rising Star in Spiritual TourismA Booming Pilgrimage Destination Barsana's significance as a key stop in the Krishna pilgrimage circuit, alongside Mathura, Vrindavan, anp Govardhan, ensures a steady influx of devotees and tourists. Millions visit annually to experience its temples, festivals, and sacred sites, driving demand for quality infrastructure and residential spaces. The town's proximity to major tourist hubs like Agra (Taj Mahal) and Delhi positions it as a prime destination for both domestic and international travelers, fueling economic growth. Real Estate Potential The real estate market in Barsana is on an upward trajectory, driven by its spiritual allure and improved connectivity. Projects like the Armed Forces Welfare Housing Organisation's Shri Bhankey Bihari Township highlight the demand for plotted developments with modern amenities. Our 32-acre township, with its premium positioning and artistic landscaping, is poised to attract discerning buyers seeking exclusive residences in a spiritually significant location. The affordability of land, compared to urban centers, makes Barsana an attractive investment opportunity. Economic and Cultural Momentum Barsana's festivals, particularly Lathmar Holi, have gained global recognition, boosting local commerce and tourismrelated businesses. The town's integration into the Braj region's cultural ecosystem, supported by events like Radhashtami and Krishna Janmashtami, ensures year-round vibrancy. As more visitors flock to Barsana, the demand for high-end residential and hospitality infrastructure will soar, making our township a visionary investment for the future. A Future-Ready LifestyleOur township is designed to capitalize on Barsana's growth while offering residents a lifestyle of unparalleled luxury. With world-class amenities, sustainable design, and proximity to sacred sites, it caters to those who value spirituality, culture, and modernity. As Barsana evolves into a global spiritual hub, your home in our township will be at the forefront of this transformation, offering both emotional fulfillment and financial returns.",
  },
  {
    title:
      "Government Developments and the Future of BarsanaEco-Restoration and Tourism Boost",
    content:
      "The Uttar Pradesh government is committed to elevating Barsana's status as a premier spiritual and eco-tourism destination. A landmark eco-restoration project, launched in 2025, aims to transform the dry hills surrounding Barsana into lush green landscapes. Starting with the 98-hectare Rakauli Hill, the initiative includes extensive plantation, water conservation, and cultural revitalization efforts. This project is expected to enhance Barsana's aesthetic appeal, attract eco-tourists, and reinforce its spiritual significance, making it an even more desirable place to live. Infrastructure and Connectivity Enhancements The government's focus on improving connectivity is set to transform Barsana's accessibility. The Yamuna Expressway already connects Barsana to Delhi and Agra in just 2 hours, while regular bus services and proximity to Mathura Junction (46 km) ensure seamless travel. Plans to upgrade road networks and public transport will further integrate Barsana with the National Capital Region (NCR), driving residential and commercial development. Cultural and Spiritual Investments The UP Tourism Department is actively promoting Barsana as part of the Braj region's heritage circuit. Investments in preserving sacred sites, enhancing festival infrastructure, and developing tourist facilities are underway. These efforts will amplify Barsana's global appeal, drawing more pilgrims and cultural enthusiasts. Nearby areas like Vrindavan and Govardhan are also benefiting from similar initiatives, creating a vibrant regional ecosystem that elevates Barsana's prominence. Your Home in Barsana's Bright Future Our 32-acre township is strategically positioned to thrive amidst these transformative developments. With breathtaking landscapes designed by a leading artist, stateof-the-art amenities, and a location steeped in divinity, it offers a rare opportunity to own a piece of Barsana's promising future. Join us in crafting a legacy where luxury meets spirituality, and your home becomes a sanctuary in the land of Radha Rani.",
  },
];

const facts = [
  {
    text: "Next Spiritual Hub",
    value:
      "The sacred home of Shri Radha Rani, is rapidly transforming into the Next Spiritual-Wellness Hub of India. Fueled by its unparalleled spiritual significance and backed by a surge in key infrastructural developments like enhanced highway connectivity and planned tourism projects, this holy land is evolving beyond a pilgrimage site. It now presents a rare convergence of timeless serenity and profound investment potential, offering discerning buyers the chance to own a premium piece of land within a locale where spirituality and high-value living are set to grow exponentially.",
  },
  {
    text: "Aanandam Valleey - One Stop Location for Your Next Home",
    value:
      "Aanandam Valleey is the first & complete, RERA-approved plotted lifestyle township. It's a secure, gated community that blends spiritual heritage with modern wellness amenities. Everything you need—from safety and community to nature and proximity to the temple—makes it the one-stop location for your dream home or investment.",
  },
  {
    text: "Affordable & Appreciating Land in Barsana",
    value:
      "Barsana offers a smart, high-growth investment. Secure your plot at an affordable price today and benefit from the steady appreciation driven by rapid infrastructural development and Barsana's status as the spiritual heart of Braj. A profitable investment in the blissful location.",
  },
  {
    text: "Connectivity & Proximity to nearby places - Braj Circuit and Delhi NCR",
    value:
      "Barsana is the central hub of the Braj Circuit (minutes from Vrindavan, Mathura, and Govardhan). It offers seamless, fast connectivity to the modern world via the Yamuna Expressway, placing Delhi NCR less than 2 hours away. The perfect blend of pilgrimage and convenience.",
  },
  {
    text: "Blissful Living Amid Nature",
    value:
      "Escape to a life of spiritual peace and serenity. Located amidst Barsana's sacred, unpolluted hills and lush green environment, this location offers a natural sanctuary. Experience true blissful living where daily life is steeped in spiritual energy and the tranquility of nature.",
  },
];

export default function WhyChooseUs() {
  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [expanded, setExpanded] = useState(
    valuesData.reduce((acc, _, i) => ({ ...acc, [i]: true }), {})
  );

  const handleToggle = (i) =>
    setExpanded((prev) => ({ ...prev, [i]: !prev[i] }));

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  };

  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0 });

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0 });
    } else {
      controls.start({ opacity: 0, y: -50 });
    }
  }, [inView, controls]);

  const funFactsRef = useRef(null);

  // ✅ FIXED toggle function
  const toggle = (index) => {
    setExpanded((prev) => {
      const updated = { ...prev };
      updated[index] = !updated[index];

      setTimeout(() => {
        if (updated[index]) {
          document.getElementById(`accordion-body-${index}`)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);

      return updated;
    });
  };

  const logos = [
    "/image/RPS.png",
    "/image/logooo.png",
    "/image/omaxe.png",
    "/image/RPS.png",
    "/image/brand.png",
    "/image/omaxe.png",
    "/image/logooo.png",
    "/image/RPS.png",
  ];

  return (
    <section className="why-container">
      <Container className="about-section">
        <Row>
          <Col lg={7} className="pe-lg-5 position-relative">
            <div>
              {/* Heading Animation */}
              <motion.h1
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                Aanandam Valley -
              </motion.h1>

              <motion.h4
                className="about-subheading"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
              >
                Where Spirituality is your neighbor
              </motion.h4>

              <motion.p
                className="about-text pinku"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
              >
                Welcome to Aanandam Valleey, a township inspired by the timeless
                culture of Barsana. More than just a place to live, it’s a way
                of life where heritage, peace, and modern comforts come
                together.<br></br>
                Every corner here reflects <b>balance</b> — of <b>tradition</b>{" "}
                and <b>progress</b>, of nature and architecture, of personal
                space and community. Here, families don’t just settle, they
                belong.
              </motion.p>

              {/* Image Animation */}
              <div className="pindi" ref={ref}>
                <motion.img
                  src={`${IMAGE_BASE_URL}/myone.png`}
                  alt="Resort View"
                  className="img-fluid about-img"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: false }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                />
              </div>
            </div>
          </Col>

          {/* Cards Section */}
          <Col lg={5} className="miki">
            <div className="sticky-box" ref={ref}>
              {[
                {
                  icon: <FaGlobeAmericas />,
                  title: "A Spiritual Township Designed for Peaceful Living",

                  text: (
                    <>
                      What sets Aanandam Valleey apart is its soul. It is
                      <b> 4 kms away from the main city of Barsana</b>, giving
                      residents the rare balance of peace and connectivity.
                      Close enough to enjoy the energy of the city, yet far
                      enough to live in calm surroundings.<br></br>
                      Here, heritage and harmony meet modern comforts. It’s not
                      just about owning a home, but about owning a lifestyle.
                    </>
                  ),
                },
                {
                  icon: <FaRegGem />,
                  title: "Vision",
                  text: "Our vision is to make Aanandam Valleey a landmark in Barsana — a township where modern living grows in harmony with centuries of culture. A place where future generations live in peace, beauty, and connection.",
                },
                {
                  icon: <FaBullseye />,
                  title: "Mission",
                  text: "Our mission is to create a community that blends heritage, wellness, and sustainability. A township where culture breathes in daily life, families enjoy a holistic lifestyle, and nature flourishes with care.",
                },
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: false }}
                  transition={{
                    duration: 0.6,
                    delay: idx * 0.3,
                    ease: "easeOut",
                  }}
                >
                  <Card id="kio" className="icon-box mb-4">
                    <div className="icon-wrapper mb-2 text-align-left">
                      {item.icon}
                    </div>
                    <Card.Title>{item.title}</Card.Title>
                    <Card.Text style={{ whiteSpace: "pre-line" }}>
                      {item.text}
                    </Card.Text>
                  </Card>
                </motion.div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
      <div className="container">
        <div className="row">
          <div className="col-1"></div>
          <div className="col-sm-10">
            <img  src={`${IMAGE_BASE_URL}/chart.jpeg`} className="img-fluid chrt-img"></img>
          </div>
                    <div className="col-1"></div>

        </div>
      </div>

      {/* <div className="fun-facts-wrapper" ref={funFactsRef}>
        <Container>
          <Row className="text-justify align-items-start flex-wrap">
            {facts.map((fact, idx) => (
              <Col
                key={idx}
                className={`fun-fact-col ${idx !== 0 ? "border-start" : ""}`}
                style={{ flex: "0 0 33%", maxWidth: "33%" }}
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{
                    opacity: 1,
                    scale: 1,
                    borderTop: "2px solid #103c3b", // ✅ border appears when in view
                    marginTop:"30px",
                    paddingTop:"20px"
                  }}
                  viewport={{ once: false }}
                  transition={{
                    duration: 0.2,
                    delay: idx * 0.2,
                    ease: "easeOut",
                  }}
                  style={{
                    borderTop: "2px solid transparent", // ✅ start with transparent border
                  }}
                >
                  <p className="fact-text">{fact.text}</p>
                  <div className="fact-number">{fact.value}</div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </div> */}
      {/* <div id="whymechoose">
        <div className="container">
          <p className="heading">30+ Years of Expertise</p>
          <div className="row">
            <div className="col-sm-12">
              <div className="container2">
                <div className="my_img">
                  <video
                    // ref={videoRef}
                    className="experince"
                    src="/video/park-a.mp4"
                    type="video/mp4"
                    preload="auto"
                    muted
                    loop
                    playsInline
                    autoPlay
                    webkit-playsinline="true"

                  ></video>
                </div>
                <div className="text-block2" data-aos="fade-right">
                  <p className="daib_txt2">
                    Barsana, the divine abode of Radha Rani, blends spirituality, culture, and serenity in perfect harmony. Surrounded by sacred hills and steeped in timeless devotion, it offers a life of peace, joy, and connection to divine heritage — where every home reflects the soul of Braj.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <section className="roji">
        {/* <Container>
          <div className="text-center mb-4">
            <h2 className="fw-bold">Why Choose Us</h2>
          </div>

          <Accordion
            id="why-choose-us"
            alwaysOpen
            defaultActiveKey={valuesData.map((_, i) => i.toString())}
          >
            {valuesData.map((item, index) => (
              <Accordion.Item eventKey={index.toString()} key={index}>
                <Accordion.Header>{item.title}</Accordion.Header>
                <Accordion.Body
                  id={`accordion-body-${index}`}
                  className="my-accordion-body"
                >
                  <div
                    className={
                      expanded[index] ? "clamp-collapsed" : "clamp-expanded"
                    }
                  >
                    <span className="typewriter-text">{item.content}</span>
                  </div>
                  <div className="read-more-box mt-3">
                    <Button
                      variant="link"
                      className="p-0 read-toggle"
                      onClick={() => toggle(index)}
                    >
                      {expanded[index] ? "Read more" : "Read less"}
                    </Button>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Container> */}
      </section>

      {/* <section className="youtube-section">
        <div className="video-wrapper">
          <iframe
            className="background-video"
            src="https://www.youtube.com/embed/1ovIKzSpNQk?controls=0&rel=0&autoplay=1&mute=1&loop=1&playlist=1ovIKzSpNQk&playsinline=1"
            title="Background Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>

        <div className="content-overlay text-center text-white">
          <h2 className="headline">Your New property is Just a Click Away!</h2>
          <a
            href="#"
            className="btn  mt-3"
            style={{ background: "#103C3B", color: "white" }}
          >
            Get Started
          </a>
        </div>
      </section> */}

      {/* <div id="mybrandsslider">
        <h2>Brand That Trust Us</h2>
        <div className="slide-track">
          {logos.concat(logos).map((logo, i) => (
            <div className="slide" key={i}>
              <img src={logo} alt="brand logo" className="logo" />
            </div>
          ))}
        </div>
      </div> */}

      {/* </div> */}
    </section>
  );
}
